import styled from "styled-components";

export const ContentContainer = styled.div`
    margin: 31px auto 100px auto;
    width: auto;
    max-width: 971px;
    min-width: 0;
    display: grid;
    grid-template-rows: auto 1fr;
    grid-template-columns: minmax(460px, 731px) minmax(180px, 232px);
    grid-gap: 8px;
    grid-template-areas:
        "head head"
        "desk options";
`

export const OptionsContainer = styled.div`
    display: grid;
    grid-gap: 8px;
    height: max-content;
    grid-area: options;
`